/** Kid-friendly blurbs for the Learn concept badges (M1 onboarding & learn).
 *  Keyed by the exact concept ids @chessmate/lessons uses. T7 + T9 pin the two lists
 *  to each other by construction. */
export const CONCEPT_EXPLANATIONS: Readonly<Record<string, string>> = {
  'piece-power': 'Every piece is worth some pawns. Trade wisely!',
  moves: 'Each piece moves its own way. Know the moves, know the game.',
  rules: 'Check, checkmate, castling and more — the rules keep the game fair.',
  'board-control': 'Pieces that watch the center control more of the board.',
  defense: 'Keep your pieces safe so the enemy cannot take them for free.',
  development: 'Bring your knights and bishops out early to join the fight.',
  'king-safety': 'Castle early and keep your king tucked away from danger.',
  puzzles: 'Puzzles make you think — find the checkmate or the big win!',
  opening: 'Start smart: develop pieces and fight for the center.',
  endgame: 'The endgame decides the game — use your king and pawns.',
  attack: 'Attack the king! Use checks, files, and your strongest pieces.',
  backgammon: 'Hit blots, escape the bar, and bear off all fifteen to win!',
  bridge: 'Count your points, follow suit, and use trump to win tricks with your partner!',
  whist: 'Team up with your partner, follow suit, and let the turned-up trump help you win tricks!',
  hearts: 'Dodge the hearts and the queen of spades: the lowest score wins!',
  'crazy-eights': 'Match the suit or the number, and play your eights wisely!',
  rummy: 'Collect sets and runs, and be the first to get rid of all your cards!',
  pirate: 'Guess exactly how many tricks you will win — an exact guess scores, a miss scores nothing!',
  'colour-dash': 'Match the colour, the number or the symbol, and call last card!',
  'mahjong-solitaire': 'Find free matching tiles and clear the whole board!',
  crowning: 'March a checker to the last row and it becomes a flying king!',
};

/** Returns the kid blurb for a concept id, or null when unknown. */
export function conceptExplanation(concept: string): string | null {
  return CONCEPT_EXPLANATIONS[concept] ?? null;
}
